import React from "react";
import { ProductListAction } from "./ProductList";
import { ProductListParams } from "./ProductListURLConfig";
import { useDispatch } from "react-redux";
import { setCustomQuery } from "../../api/productListSlice";
import { setCustomQueryContent } from "./CustomQueryHint";
import { useGetCustomerQuery } from "../../api/customerApi";
import { hasActiveFilters } from "./utils";
import { Button, Icon } from "../../components/tailwind";
import { generateIdQueryHref } from "../IdQuery";

type Props = {
  searchQuery: string;
  onAction: (action: ProductListAction, value?: unknown) => void;
  currentParameters: ProductListParams;
};

export const ProductListSearchbar: React.FC<Props> = ({
  searchQuery,
  onAction,
  currentParameters,
}) => {
  const dispatch = useDispatch();
  const { data: customer, isLoading } = useGetCustomerQuery();

  return (
    <div data-testid="product-list-search-bar" className="tw-w-full tw-mb-8">
      <form
        data-testid="product-list-search-bar-form"
        className="tw-flex tw-items-center tw-gap-4"
        onSubmit={(e): void => {
          e.preventDefault();
          const target = e.target as typeof e.target & {
            search: { value: string };
          };
          onAction(
            ProductListAction.UpdateSearchBar,
            target.search.value || ""
          );
        }}
      >
        <div className="tw-grid tw-grid-cols-4">
          <input
            autoFocus
            key={searchQuery ? "active" : "inactive"}
            defaultValue={searchQuery}
            data-testid="searchQuery"
            placeholder="Search SKU, EAN or any word…"
            name="search"
            className="tw-w-full txu-input tw-col-span-3"
            type="text"
          />
          <Button
            type="submit"
            data-testid="searchButton"
            variant="primary"
            size="sm"
            icon
          >
            <Icon name="search" />
            Search
          </Button>
        </div>

        <Button
          data-testid="product-list-search-bar-search-many-ids-button"
          variant="primary"
          size="sm"
          icon
          onClick={(): void => {
            window.location.href = generateIdQueryHref({
              customerSlug: customer?.slug,
            });
          }}
        >
          <Icon name="manage_search" />
          ID-list search...
        </Button>

        {hasActiveFilters(customer, currentParameters) && (
          <Button
            type="button"
            disabled={isLoading}
            data-testid="product-list-search-bar-clear-filter-button"
            variant="secondary-alt"
            size="sm"
            icon
            onClick={(): void => {
              onAction(ProductListAction.Reset, currentParameters);
              dispatch(
                setCustomQuery(setCustomQueryContent({ customer, query: "" }))
              );
            }}
          >
            <Icon name="delete" />
            Clear filters
          </Button>
        )}
      </form>
    </div>
  );
};
